module.exports = "<lc-navigation-bar background=\"background--dm\"\n                   text=\"\"\n                   mode=\"anonymous_order\"></lc-navigation-bar>\n\n<div class=\"section shop_section\">\n  <lc-productlist [language]=\"dataService.current_language\" mode=\"anonymous\" type=\"products\"></lc-productlist>\n</div>\n\n<lc-footer-bar></lc-footer-bar>\n"


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/anon-shop-page/anon-shop-page.component.html
// module id = ../../../../../src/app/pages/anon-shop-page/anon-shop-page.component.html
// module chunks = main